import React from 'react';
import { Dialog, Notification, TypographyBody, BellIcon, DialogHeader, DialogContent, } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function ErrorNavlRetryModal(props) {
    const { resourceStrings: { HC_HOTELROOMS_NAVL_TITLE, HC_HOTELROOMS_NAVL_BODY }, } = useGlobalContext();
    return (React.createElement(Dialog, Object.assign({}, props),
        React.createElement(DialogHeader, { "data-id": "room-details-dialog", withCloseButton: true, border: false },
            React.createElement(TypographyBody, { weight: "bold", "data-id": "room-sold-out-heading" }, HC_HOTELROOMS_NAVL_TITLE)),
        React.createElement(DialogContent, { pb: 4 },
            React.createElement(Notification, { color: "warning", icon: React.createElement(BellIcon, null) },
                React.createElement("p", null, HC_HOTELROOMS_NAVL_BODY)))));
}
